<template>
  <div class="container"></div>
</template>

<script>
/* tslint:disable */
import { guidesJourneyQuery, isGuidesContext } from '@/helpers/appContext';
import { LOGIN } from '@/routerNames';
import notificationService from '@/services/NotificationService';

export default {
  name: 'LoginSocialFailPage',
  props: ['message'],
  created() {
    notificationService.error(this.message);
    // A bare login would end a Guides journey: it says "Sign in to Snaplore", and signing up from there
    // creates a Snaplore company.
    this.$router.push({ name: LOGIN, query: isGuidesContext() ? guidesJourneyQuery() : {} });
  },
};
</script>
